// 课程列表
const productList = () => import('@/pages/arkHome/productList.vue');

// 电子书的列表
const productListEBook = () => import('@/pages/arkHome/productListEBook.vue');
const guidanceList = () => import('@/pages/arkHome/guidanceList.vue');
const productListFromBank = () => import('@/pages/arkHome/productListFromBank.vue');
const productListFromMiniTools = () => import('@/pages/arkHome/productListFromMiniTools.vue');
const hotSaleList = () => import('@/pages/arkHome/hotSaleList.vue');

const hotSaleListReport = () => import('@/pages/arkHome/hotSaleListReport.vue');
const projectCourseList = () => import('@/pages/arkHome/projectCourseList.vue');
const producIdtList = () => import('@/pages/arkHome/producIdtList.vue');
const productListcode = () => import('@/pages/productListCode/index.vue');
const limitProduct = () => import('@/pages/arkHome/limitProduct.vue');

export default [
  {
    path: '/productList',
    name: 'productList',
    component: productList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/productListEBook',
    name: 'productListEBook',
    component: productListEBook,
    meta: {
      title: '电子书列表',
    },
  },
  {
    path: '/producIdtList',
    name: 'producIdtList',
    component: producIdtList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/productList-from-bank',
    component: productListFromBank,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/guidanceList',
    component: guidanceList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/hotSaleList',
    component: hotSaleList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/hotSaleListReport',
    component: hotSaleListReport,
    meta: {
      title: '一对一课程',
    },
  },
  {
    path: '/productList-from-mini-tools',
    component: productListFromMiniTools,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/projectCourseList',
    component: projectCourseList,
    meta: {
      title: '精品专题课',
    },
  },
  {
    path: '/productListcode',
    name: 'productListcode',
    component: productListcode,
  },
  {
    path: '/limitProduct',
    name: 'limitProduct',
    component: limitProduct,
    meta: {
      title: '课程列表',
    },
  },
];
